/**
 * HistorieTab - the Ausschreibungs-Screen Tab 6 (P2 Placement Slice 15): the Abschluss section above
 * the read-only Historie timeline.
 */
import { AbschlussSection } from './AbschlussSection';
import { PlacementHistorie } from './PlacementHistorie';

export function HistorieTab({ placementId, canWrite, canSend }: { placementId: string; canWrite: boolean; canSend: boolean }) {
  return (
    <div className="space-y-6" data-testid="placement-historie-tab">
      <AbschlussSection placementId={placementId} canWrite={canWrite} canSend={canSend} />
      <PlacementHistorie placementId={placementId} />
    </div>
  );
}
